<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-01-30 18:41:06
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-03-15 16:59:42
 * @FilePath: \ioc_base\src\modules\visitorRecord\components\details-dialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <!-- <div class="detail-box-dialog"> -->
  <div
    class="dialog-app-panel detail-box-dialog"
    :class="detailVisible ? 'dialog-show' : ''"
  >
    <appPanel
      class="app-panel"
      :isExpand="detailVisible"
      title="预约详情"
      @cancel="handleCancel"
    >
      <!-- <el-dialog
      title="预约详情"
      :visible.sync="detailVisible"
      v-dialogDrag
      :modal="false"
      width="40%"
      class="detail-continer"
    > -->
      <el-scrollbar style="100%">
        <el-form
          v-if="templateData && templateData.length"
          style="margin: 16px"
        >
          <ioc-tab-group
            ref="iocGroup"
            :option="tabOption"
            @change="handleChange"
          ></ioc-tab-group>
          <div v-if="selector.prop === 'tab1'" style="padding: 12px">
            <el-row v-if="templateData[0].display != '0'">
              <div style="width: 50%">
                <el-col :span="24" v-if="templateData[1].display != '0'">
                  <el-form-item label="姓名：">
                    {{ detailData.name }}
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="templateData[2].display != '0'">
                  <el-form-item label="性别：">
                    {{ detailData.sex | sexFilter }}
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="templateData[3].display != '0'">
                  <el-form-item label="电话：">
                    {{ detailData.phone }}
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-if="templateData[4].display != '0'">
                  <el-form-item label="身份证：">
                    {{ detailData.idCard }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="申请入厂时间：">
                    {{ detailData.enterTime }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="申请出厂时间：">
                    {{ detailData.exitTime }}
                  </el-form-item>
                </el-col>
                <div v-if="detailData.delayedTime">
                  <el-col :span="24">
                    <el-form-item label="延时时间：">
                      {{ detailData.delayedTime }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="延时理由：">
                      {{ detailData.delayedReason }}
                    </el-form-item>
                  </el-col>
                </div>
              </div>
              <div>
                <el-col
                  :span="24"
                  style="display: flex; flex-direction: column"
                >
                  <!-- <el-form-item label="外来人员照片："> -->
                  <img
                    :src="imgPath(detailData.fileCode)"
                    @click="showViewer(imgPath(detailData.fileCode), $event)"
                    class="stranger_img"
                    title="访客人脸照片"
                    onerror="this.src='/images/theme/newDark/default.png'"
                  />
                  <img
                    :src="imgPath(detailData.idCardFileCode)"
                    @click="
                      showViewer(imgPath(detailData.idCardFileCode), $event)
                    "
                    class="stranger_img"
                    title="访客有效证件照"
                    onerror="this.src='/images/theme/newDark/default.png'"
                  />

                  <!-- </el-form-item> -->
                </el-col>
              </div>
            </el-row>
            <el-row>
              <el-col :span="12" v-if="showPlateCode">
                <el-form-item label="车牌号：">
                  {{ detailData.plateCode }}
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="车辆颜色：">
                  {{ detailData.vehicleColor | colorFilter }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车辆类型：">
                  {{ detailData.vehicleType | vehicleTypeFilter }}
                </el-form-item>
              </el-col> -->
              <!-- <span
                style="width: 100%"
                v-for="(item, index) in detailData.appointmentReceptionistList"
                :key="item.workNo"
              >
                <el-col :span="12">
                  <el-form-item :label="'被拜访人'+(index+1)">
                    {{ item.name }}【 {{ item.phone }}】
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="部门：">
                   {{item.departmentName}}
                  </el-form-item>
                </el-col>
              </span> -->

              <!-- <el-col :span="12">
                <el-form-item label="厂内 / 厂外：">
                  {{ isFactoryFormatter(detailData.isFactory) }}
                </el-form-item>
              </el-col> -->
              <el-col :span="24">
                <el-form-item label="来访事由：">
                  <div style="display: flex">
                    {{ detailData.visitorReason }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="访客类型：">
                  {{ detailData.visitorTypeName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="人员通行权限：">
                  {{ detailData.turnstileGateDeviceNames }}
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="detailData.isCar == 1">
                <el-form-item label="停车场：">
                  {{ detailData.parkinglotName }}
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="detailData.isCar == 1">
                <el-form-item label="车辆通行权限：">
                  {{ detailData.vehicleBarrierDeviceNames }}
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="selector.prop === 'tab2'" style="padding: 12px">
            <p
              v-if="
                detailData.partnterList && detailData.partnterList.length === 0
              "
              style="line-height: 50px; text-align: center"
            >
              无随行人员
            </p>
            <el-row
              v-for="(item, ind) in detailData.partnterList"
              :key="ind"
              v-else
              class="entourage-container"
            >
              <div style="width: 50%">
                <el-col :span="24">
                  <el-form-item label="随行人员">
                    {{ ind + 1 }}
                  </el-form-item>
                </el-col>

                <el-col :span="24" v-if="templateData[12].display != '0'">
                  <el-form-item label="姓名：">
                    {{ item.name }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="性别："
                    v-if="templateData[13].display != '0'"
                  >
                    {{ item.sex | sexFilter }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="电话："
                    v-if="templateData[14].display != '0'"
                  >
                    {{ item.phone }}
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="身份证："
                    v-if="templateData[15].display != '0'"
                  >
                    {{ item.idCard }}
                  </el-form-item>
                </el-col>
              </div>
              <div style="width: 40%">
                <el-col :span="24" v-if="templateData[11].display != '0'">
                  <!-- <el-form-item label="照片："> -->
                  <img
                    :src="imgPath(item.partnerUrl)"
                    @click="showViewer(imgPath(item.partnerUrl), $event)"
                    class="stranger_img"
                    title="随行人员照片"
                    style="margin-bottom: 10px"
                    onerror="this.src='/images/theme/newDark/default.png'"
                  />
                  <!-- </el-form-item> -->
                </el-col>
                <el-col
                  :span="24"
                  style="display: flex; flex-direction: column"
                >
                  <img
                    :src="imgPath(item.idCardFileCode)"
                    @click="showViewer(imgPath(item.idCardFileCode), $event)"
                    class="stranger_img"
                    title="有效证件照"
                    onerror="this.src='/images/theme/newDark/default.png'"
                  />
                </el-col>
              </div>
            </el-row>
          </div>
          <div v-if="selector.prop === 'tab4'" style="padding: 12px">
            <el-row
              v-for="(item, ind) in detailData.appointmentReceptionistList"
              :key="ind"
              class="entourage-container"
            >
              <el-col :span="24">
                <el-form-item label="被拜访人">
                  {{ ind + 1 }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="姓名：">
                  {{ item.name }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="工号：">
                  {{ item.workNo }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电话：">
                  {{ item.phone }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="部门：">
                  {{ item.departmentName }}
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="selector.prop === 'tab3'" style="padding: 12px">
            <div class="process-container">
              <el-timeline direction="vertical" class="timeLine">
                <el-timeline-item
                  v-for="(flowItem, index) in workFlowDetail"
                  :key="index"
                  placement="top"
                  :timestamp="flowItem.operatTime"
                >
                  <!-- <el-card> -->
                  <p class="action">
                    状态：
                    {{ flowItem.status | flowStatusFilter }}
                  </p>
                  <div class="process-step-content">
                    <div class="left-box">
                      <p class="lh30">{{ flowItem.type | flowTypeFilter }}</p>
                      <p class="lh30" v-if="flowItem.type === '3'">
                        {{ "(" + flowItem.areaDevGroupName + ")" }}
                      </p>
                      <p class="lh30">{{ flowItem.operatorName }}</p>
                    </div>
                    <!-- <div
                      style="border: none; color: #409eff"
                      v-if="flowItem.status !== '0' && flowItem.status !== '99'"
                      @click.stop="cardClick(flowItem)"
                    >
                      查看详情
                    </div> -->
                    <!-- <div class="right-box" style="width: 150px">
                      <p class="lh30">{{ flowItem.operatTime }}</p>
                      <p class="lh30">
                        {{ flowItem.status | flowStatusFilter }}
                      </p>
                      <span
                        style="border: none; color: #409eff"
                        v-if="
                          flowItem.status !== '0' && flowItem.status !== '99'
                        "
                        @click.stop="cardClick(flowItem)"
                        >查看详情</span
                      >
                    </div> -->
                  </div>
                  <!-- </el-card> -->
                  <!-- <template>
                    <div style="position:absolute;left:85px;top:-7px">
                      <span style="border:none;color:#00e8bb"
                            @click.stop="getDetailsList(flowItem)">查看详情</span>
                    </div>
                  </template> -->
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-row>
          <el-row v-if="selector.prop === 'tab5'" style="padding: 12px">
            <div class="process-container">
              <el-timeline direction="vertical" class="timeLine">
                <div class="line-title">人员通行闸机</div>
                <el-table
                  :data="detailData.turnstilegateTrafficRecordList"
                  style="width: 100%"
                  height="200"
                >
                  <el-table-column type="index" width="50"> </el-table-column>
                  <el-table-column
                    prop="personnelName"
                    label="姓名"
                    width="110"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="deviceName"
                    label="通行闸机"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="trafficType"
                    label="进/出场"
                    width="110"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.trafficType === "1"
                          ? "进场"
                          : scope.row.trafficType === "0"
                          ? "出场"
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="trafficTime" label="通行时间">
                  </el-table-column>
                </el-table>
                <div class="line-title">车辆通行道闸</div>
                <el-table
                  :data="detailData.vehicleBarrierTrafficRecordList"
                  style="width: 100%"
                  height="200"
                >
                  <el-table-column type="index" width="50"> </el-table-column>
                  <el-table-column prop="plateCode" label="车牌号" width="110">
                  </el-table-column>
                  <el-table-column
                    prop="deviceName"
                    label="通行道闸"
                    width="180"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="trafficType"
                    label="进/出场"
                    width="110"
                  >
                    <template slot-scope="scope">
                      {{
                        scope.row.trafficType === "1"
                          ? "进场"
                          : scope.row.trafficType === "0"
                          ? "出场"
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="trafficTime" label="通行时间">
                  </el-table-column>
                </el-table>

                <!-- <el-row
                  v-for="(
                    item, ind
                  ) in detailData.turnstilegateTrafficRecordList"
                  :key="ind"
                  class="entourage-container"
                >
                  <el-col :span="24">
                    <el-form-item label="被拜访人">
                      {{ ind + 1 }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="姓名：">
                      {{ item.name }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="工号：">
                      {{ item.workNo }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="电话：">
                      {{ item.phone }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="部门：">
                      {{ item.departmentName }}
                    </el-form-item>
                  </el-col>
                </el-row> -->
              </el-timeline>
            </div>
          </el-row>
        </el-form>
      </el-scrollbar>
      <!-- </el-dialog> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel" type="info"> 关闭 </el-button>
      </span>
    </appPanel>
    <el-dialog
      title="工作流详情"
      :visible.sync="singleDetailVisible"
      v-dialogDrag
      append-to-body
      width="30%"
    >
      <el-form>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="通行区域："
              v-if="workFlowType === '1' && detailData.isFactory === '0'"
            >
              {{ singleWorkFlowDetail.areaDevGroupNames }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="通行道闸："
              v-if="workFlowType === '1' && detailData.isCar === '1'"
            >
              {{ singleWorkFlowDetail.vehicleBarrierThirdDeviceNames }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="抄送人员："
              v-if="
                (workFlowStatus === '5' || workFlowStatus === '7') &&
                workFlowType === '4'
              "
            >
              {{ singleWorkFlowDetail.copySendName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="通行生效时间："
              v-if="
                (workFlowType === '1' || workFlowType === '2') &&
                detailData.isCar === '1'
              "
            >
              {{ singleWorkFlowDetail.vehicleBarrierEffectiveTime }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="通行失效时间："
              v-if="
                (workFlowType === '1' || workFlowType === '2') &&
                detailData.isCar === '1'
              "
            >
              {{ singleWorkFlowDetail.vehicleBarrierExpirationTime }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="remarkText + '：'">
              {{ singleWorkFlowDetail.remark }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="操作时间：">
              {{ singleWorkFlowDetail.operatTime }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import appPanel from "@src/components/business/app-panel/index";
import { Dic, Bus, Dates } from "$utils";
import { api } from "../api";
export default {
  name: "details-Dialog",
  components: {
    appPanel,
  },
  props: {},
  filters: {
    sexFilter(val, SENU) {
      return Dic.findByValue("SENU018", val);
    },
    colorFilter(val) {
      return Dic.findByValue("SENU039", val);
    },
    vehicleTypeFilter(val) {
      return Dic.findByValue("SENU038", val);
    },
    formartterTime(time) {
      return time
        ? Dates.dayjs(Number(time)).format("YYYY-MM-DD HH:mm:ss")
        : "";
    },
    flowTypeFilter(val) {
      return Dic.findByValue("SENU080002", val);
    },
    flowStatusFilter(val) {
      return Dic.findByValue("SENU080003", val);
    },
  },
  data() {
    return {
      templateCode: "",
      detailVisible: false,
      singleDetailVisible: false,
      detailData: {},
      //模板数据
      templateData: [],
      workFlowDetail: [],
      tabOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: "外来人员信息",
            prop: "tab1",
          },
          {
            label: "随行人员信息",
            prop: "tab2",
          },
          {
            label: "被拜访人",
            prop: "tab4",
          },
          {
            label: "流程信息",
            prop: "tab3",
          },
          {
            label: "通行记录",
            prop: "tab5",
          },
        ],
      },
      showPlateCode: true,
      selector: {},
      singleWorkFlowDetail: {},
      // 单个工作流详情
      workFlowStatus: "",
      workFlowType: "",
      remarkText: "",
    };
  },
  mounted() {},
  created() {
    this.selector = this.tabOption.column[0];
  },
  methods: {
    handleCancel() {
      this.detailVisible = false;
      this.$refs.iocGroup.reset();
      this.selector = this.tabOption.column[0];
    },
    isFactoryFormatter(data) {
      switch (data * 1) {
        //
        case 0:
          return "厂内";
        case 1:
          return "厂外";
        default:
          return data;
      }
    },
    // 选项卡被选中时触发
    handleChange(column) {
      this.selector = column;
    },
    imgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(src, e) {
      this.$app.AppInstance.handleShowViewer([src || e.target.src]);
      // this.viewerPhotos = [
      //   e.target.src.indexOf("default/default.png") == -1
      //     ? e.target.src + "&sourceFileFlag=1"
      //     : e.target.src,
      // ];
      // this.viewerInstance.show();
    },
    open(code) {
      let params = {
        appointmentCode: code,
      };
      this.$fetch(api.queryVisitorApplyDetail, params).then((res) => {
        if (res.success) {
          this.detailData = res.returnObj;
          this.detailData.isCar == "0"
            ? (this.showPlateCode = false)
            : (this.showPlateCode = true);
          this.templateCode = this.detailData.templateCode;
          this.getFiled();
          this.detailVisible = true;
          // this.detailData.turnstilegateTrafficRecordList = [
          //   {
          //     personnelCode: null,
          //     personnelType: null,
          //     thirdDeviceId: "1005471$7$0$0",
          //     trafficTime: "2023-08-17 17:58:20",
          //     trafficType: 1,
          //     plateNo: null,
          //     personnelName: "徐三三",
          //     deviceName: "2号冷库-人脸门禁1",
          //   },
          //   {
          //     personnelCode: null,
          //     personnelType: null,
          //     thirdDeviceId: "1005471$7$0$0",
          //     trafficTime: "2023-08-17 17:52:20",
          //     trafficType: 1,
          //     plateNo: null,
          //     personnelName: "徐三三",
          //     deviceName: "2号冷库-人脸门禁1",
          //   },
          // ];
        } else {
          this.$message.error(res.msgContent);
        }
      });
      this.getWorkFlowDetail(params);
    },
    // 获取模板字段
    getFiled() {
      let params = {
        templateCode: this.templateCode,
      };
      this.$fetch(api.config.getTemplateField, params).then((res) => {
        if (res.success) {
          this.templateData = res.returnObj;
          // if(this.templateData.)
          console.log(this.templateData, "=this.templateData=============");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    getWorkFlowDetail(params) {
      this.$fetch(api.queryAppointmentWorkflow, params).then((response) => {
        if (!response.success) {
          this.$message({
            message: response.msgContent,
            type: "error",
            duration: 2000,
          });
          return;
        }
        this.workFlowDetail = response.returnObj;
      });
    },
    cardClick(item) {
      this.workFlowStatus = item.status;
      this.workFlowType = item.type;
      if (this.workFlowStatus === "5") {
        this.remarkText = "签到意见";
      } else if (this.workFlowStatus === "7") {
        this.remarkText = "签离意见";
      } else {
        this.remarkText = "审批意见";
      }
      let params = {
        workflowCode: item.workflowCode,
      };
      if (item.status === "0" || item.status === "99") {
        return false;
      } else {
        this.singleDetailVisible = true;
        this.$fetch(api.singleFlowDetail, params).then((response) => {
          if (!response.success) {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
            return;
          }
          this.singleWorkFlowDetail = response.returnObj;
        });
      }
    },
  },
};
</script>

<style lang="scss" >
@import "../style/visitorRecord.scss";
.left-box,
.el-timeline-item__timestamp {
  color: black !important;
}
.line-title {
  margin: 10px 0;
}
.detail-box-dialog {
  .stranger_img {
    margin-bottom: 16px;
    width: 170px !important;
    height: 120px !important;
    cursor: pointer;
  }
}

.process-container {
  width: 100%;
  .el-timeline-item__node {
    box-shadow: 0px 0px 5px 4px #407aee;
  }
  .timeLine {
    width: 100%;
  }

  .el-timeline-item__timestamp {
    color: #ffffff;
  }
  .process-step-content {
    color: #ffffff;
  }
  .el-timeline-item__content {
    width: 100%;
    // color: #ffffff;
    p {
      margin: 12px 0;
    }
    .action {
      position: absolute;
      top: -17px;
      left: 200px;
      color: #fff;
      background: #407aee;
      padding: 4px 8px;
      border-radius: 5px;
    }
  }
}

// }
</style>
